import React from "react";

export function DashbboardHelp3() {
    return (
        <div style={{
            fontFamily: 'PPMoriRegular',
            textAlign: 'justify',
            marginRight: 40,
            fontSize: '1.2em'
        }}>
            <p>Vegetation and various forms of non-built-up land cover play a crucial role in the sequestration of CO2,
                acting as natural carbon sinks that absorb and store carbon dioxide from the atmosphere. The region's
                forests, rich in biodiversity and expansive in coverage, act as vital carbon sinks. They capture CO2
                from the atmosphere and store it in their biomass and soil, a process that is essential for reducing the
                overall concentration of greenhouse gasses. Protecting these forests from deforestation and degradation
                is therefore not only critical for preserving biodiversity but also for maintaining their capacity to
                absorb carbon dioxide.
            </p>
            <p>However, beyond forests, grasslands and agricultural lands also contribute to carbon
                sequestration. Though not as efficient per unit area as forests, these lands still absorb and store
                significant amounts of carbon. Sustainable agricultural practices and the maintenance of grasslands can
                enhance their capacity to sequester carbon. Practices such as agroforestry, cover cropping, and reduced
                tillage not only improve soil health but also increase the amount of carbon that these soils can
                retain.</p>
            <p>To take into account of these aspects, the vegetation sequestration component of the Carbon Footprint
                Simulator considers the following parameters:
                <ul>
                    <li>Type of land cover (natural rainforest, mangrove forest, palm oil plantation, mixed agriculture,
                        other, permanent water bodies, artificial)
                    </li>
                    <li>CO2 sequestration efficiency of each land cover</li>
                </ul></p>
            <p>Upon choosing a specific province, users can adjust the proportion of total land surface area occupied by
                different land uses (excluding permanent water bodies and urban areas). These adjustments enable the
                visualization of the corresponding rise or fall in CO2 sequestration driven by different types of
                non-build up land covers.</p>
        </div>
    )
}